import type { HelpFile } from '../../types/help'
import { SystemDetailTestIds } from '../../../testids/SystemDetailTestIds'

export const systemDetailHelp: HelpFile = {
  docPage: '/docs/systems/overview',
  texts: {
    [SystemDetailTestIds.systemDetailPage]:
      'Detailseite eines Zielsystems — Attribute, Ressourcen, Konnektor und Abbruchverhalten auf einen Blick.',
    [SystemDetailTestIds.cardSystemDetails]:
      'Stammdaten des Zielsystems: Bezeichner, Typ und Eigentümerschaft.',
    [SystemDetailTestIds.cardTitleConnector]:
      'Verknüpfter Konnektor für ausgehende Bereitstellung und eingehende Synchronisation.',
    [SystemDetailTestIds.sectionAttributes]:
      'Attributwerte, die für dieses Zielsystem konfiguriert sind.',
    [SystemDetailTestIds.sectionResources]:
      'Ressourcen, die auf diesem System definiert sind und als Ziel für Berechtigungen und Zuweisungen dienen.',
    [SystemDetailTestIds.terminationActionLabel]:
      'Aktion, die beim Beenden einer Identität auf deren Konten in diesem System ausgeführt wird.',
    [SystemDetailTestIds.connectorCapabilityBanner]:
      'Zeigt, welche Bereitstellungsoperationen der verknüpfte Konnektor aktuell unterstützt.',
    [SystemDetailTestIds.btnAddConnector]:
      'Konnektor verknüpfen, um Bereitstellung und eingehende Synchronisation für dieses System zu aktivieren.',
    [SystemDetailTestIds.btnDeleteSystem]:
      'Dieses Zielsystem löschen. Wird mit 409 abgelehnt, solange noch Ressourcen, Enforcement Objects oder Konten darauf verweisen.',
    [SystemDetailTestIds.linkConnectorDetail]: null,
    [SystemDetailTestIds.colName]: null,
    [SystemDetailTestIds.colType]: null,
    [SystemDetailTestIds.colClassification]:
      'Klassifizierung der Ressource — z. B. Schutzbedarf oder Compliance-Stufe.',
    [SystemDetailTestIds.colEoResource]:
      'Ressource, zu der dieses Enforcement Object auf diesem Zielsystem gehört.',
  },
}
